/* ============================================================
  AB-07-PP — functional JS
  Handles: accordion toggle, modal open/close, GTM analytics.
  HTML and CSS are static files — nothing is generated here.
  ============================================================ */
(function () {
  'use strict';

  var NS      = 'ab07';
  var ROOT_ID = 'ab07-wiwfm';

  /* ── DOM refs ──────────────────────────────────────────────── */
  var row     = document.getElementById(ROOT_ID);
  var overlay = document.getElementById(ROOT_ID + '-overlay');

  if (!row || !overlay) return; /* guard: HTML not present in DOM */

  var titleEl = row.querySelector('.collapse-item__title');
  var panelEl = row.querySelector('.collapse-item__content');

  /* ── Accordion toggle ──────────────────────────────────────── */
  /*
     custom.js binds collapse-item clicks directly at load; this
     injected row arrives after that, so it gets no native handler.
     We reproduce the theme's exclusive-accordion behavior: opening
     one row closes every other.
  */
  function toggle() {
    var isOpen = titleEl.classList.contains('active');

    if (isOpen) {
      titleEl.classList.remove('active');
      titleEl.setAttribute('aria-expanded', 'false');
      panelEl.style.display = 'none';
      track('ab07_section_toggle', { state: 'close' });
    } else {
      /* close every other accordion panel */
      Array.prototype.forEach.call(
        document.querySelectorAll('.collapse-item__content'),
        function (c) { if (c !== panelEl) c.style.display = 'none'; }
      );
      /* deactivate every other accordion title */
      Array.prototype.forEach.call(
        document.querySelectorAll('.collapse-item__title'),
        function (t) { if (t !== titleEl) t.classList.remove('active'); }
      );

      titleEl.classList.add('active');
      titleEl.setAttribute('aria-expanded', 'true');
      panelEl.style.display = 'block';
      track('ab07_section_toggle', { state: 'open' });
    }
  }

  titleEl.addEventListener('click', toggle);
  titleEl.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
  });

  /* ── Modal ─────────────────────────────────────────────────── */
  var lastFocus = null;

  function openModal(key) {
    var mod = document.getElementById('ab07-modal-' + key);
    if (!mod) return;

    lastFocus = document.activeElement;

    /* hide any previously visible modal */
    Array.prototype.forEach.call(
      overlay.querySelectorAll('.' + NS + '-mod'),
      function (m) { m.hidden = true; }
    );

    mod.hidden = false;
    overlay.hidden = false;
    overlay.scrollTop = 0;
    document.documentElement.style.overflow = 'hidden'; /* lock background scroll */

    var closeBtn = mod.querySelector('.' + NS + '-x');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    /* hide all modal panels */
    Array.prototype.forEach.call(
      overlay.querySelectorAll('.' + NS + '-mod'),
      function (m) { m.hidden = true; }
    );
    overlay.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus) { lastFocus.focus(); lastFocus = null; }
  }

  /* sub-link clicks inside the accordion panel */
  panelEl.addEventListener('click', function (e) {
    var anchor = e.target.closest ? e.target.closest('[data-' + NS + '-modal]') : null;
    if (!anchor) return;
    e.preventDefault();
    var key = anchor.getAttribute('data-' + NS + '-modal');
    track('ab07_link_click', { link: key });
    openModal(key);
  });

  /* click on overlay backdrop or any close button */
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) { closeModal(); return; }
    if (e.target.closest && e.target.closest('.' + NS + '-x')) closeModal();
  });

  /* Escape key closes the modal */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) closeModal();
  });

  /* ── Analytics (GTM) ───────────────────────────────────────── */
  /* Silently skipped if dataLayer is absent — analytics must never
     break the variant. */
  function track(event, data) {
    try {
      if (!window.dataLayer || typeof window.dataLayer.push !== 'function') return;
      var payload = { event: event };
      for (var k in data) {
        if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k];
      }
      window.dataLayer.push(payload);
    } catch (e) { /* swallow */ }
  }

})();
